import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
    useAddTransportCategoryMutation,
    useDeleteTransportCategoryMutation,
    useEditTransportCategoryMutation
} from "../../../../redux/api/handBooksApi/transportCategoryApi";
import { EntTransportCategory } from "../../../../models/handBooks/transportCategory";
import { getCookie } from "typescript-cookie";

const useTransportCategory = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addTransportCategory] = useAddTransportCategoryMutation();
    const [deleteTransportCategory] = useDeleteTransportCategoryMutation();
    const [editTransportCategory] = useEditTransportCategoryMutation();

    async function onAddTransportCategory(newTransportCategory: EntTransportCategory): Promise<boolean> {
        try {
            let status: boolean = false;
            await addTransportCategory(newTransportCategory).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteTransportCategory(transportCategory: EntTransportCategory) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTransportCategory(transportCategory.id as number).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditTransportCategory(editedTransportCategory: EntTransportCategory): Promise<boolean> {
        try {
            let status: boolean = false;
            await editTransportCategory(editedTransportCategory).then((response: any) => {
                  if (response.error) {
                                              const isKyrgyz = getCookie('i18next') === 'ky';
                                              const lang = isKyrgyz ? 'kg' : 'ru';
                                              const res = response.error.data?.res;
                                              const errorMessages = Array.isArray(res)
                                                  ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                  : response.error.data?.msg || t('unknownError'); 
                                              throw new Error(errorMessages);
                                          }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddTransportCategory, onDeleteTransportCategory, onEditTransportCategory }
}

export { useTransportCategory };
